export const buildInventoryMethods = (graphQLClient) => ({
  fetch: {
    byProductId: async (productId) => {
      const inventoryQuery = `query {
          product(id: "${productId}") {
            id
            variants(first: 10) {
              edges {
                node {
                  sku
                  quantityAvailable
                }
              }
            }
          }
        }`

      try {
        const response = await graphQLClient({ query: inventoryQuery })
        const { data, errors } = response

        if (errors && errors.length > 0) return {}

        const {
          product: {
            variants: { edges: variants },
          },
        } = data

        return variants.reduce((allVariants, { node }) => {
          const { sku, quantityAvailable } = node
          allVariants[sku] = quantityAvailable
          return allVariants
        }, {})
      } catch (error) {
        console.error('Error fetching inventory byProductId', error)
        return {}
      }
    },
    byProductIds: async (productIdsArr) => {
      const idsQuery = productIdsArr.join(' OR ')
      const inventoryQuery = `
          query {
            products(first: 100, query: "${idsQuery}") {
              edges {
                node {
                  id
                  variants(first: 10) {
                    edges {
                      node {
                        sku
                        quantityAvailable
                      }
                    }
                  }
                }
              }
            }
          }`

      try {
        const response = await graphQLClient({ query: inventoryQuery })
        const { data, errors } = response

        if (errors && errors.length > 0) return null

        const {
          products: { edges },
        } = data

        if (!edges?.length) return null

        const allStock = edges.reduce((allStock, { node: product }) => {
          const {
            variants: { edges: variants },
            id,
          } = product

          const productVariantStock = variants.reduce(
            (allVariants, { node: variant }) => {
              const { sku, quantityAvailable } = variant
              allVariants[sku] = quantityAvailable
              return allVariants
            },
            {},
          )

          return {
            ...allStock,
            [id]: productVariantStock,
          }
        }, {})

        return allStock
      } catch (error) {
        console.error('Error fetching inventory byProductIds', error)
        return {}
      }
    },
  },
})
